import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CalendarIcon } from '../../../Assets/icons';
const DatePickerPopup = ({ value, setter, tomorrow = new Date() }) => {
  const datePickerRef = useRef(null);

  return (
    <>
      <style>
        {`
        div.popup-calender .react-datepicker-popper{
        right:0 !important;
        }
         div.popup-calender .react-datepicker__triangle{
        display:none !important;
        }
       div.popup-calender .react-datepicker-popper{
    //    display:none !important; 
       }
        `}
      </style>

      <div className={'popup-calender'} style={{ display: 'flex', alignItems: 'center' }}>
        {/* Calendar icon that opens the date picker */}
        <CalendarIcon
          size={24}
          onClick={() => datePickerRef.current.setOpen(true)} // Open calendar on icon click
          style={{ cursor: 'pointer', marginRight: '10px' }}
        />

        {/* Hidden DatePicker input field */}
        <DatePicker
          onChange={(date) => {
            if (typeof setter === 'function') setter(date); // Call external setter if provided
          }}
          placeholderText="dd/mm/yyyy"
          minDate={tomorrow} // Prevents selecting today and past dates, allows only future dates
          dateFormat="dd MMMM yyy" // Custom format for the date
          showYearDropdown // Show year dropdown
          scrollableYearDropdown // Allows scrolling through years
          ref={datePickerRef} // Ref to control the DatePicker
          customInput={<input style={{ display: 'none' }} />} // Hide the input
        />
      </div>
    </>
  );
};

export default DatePickerPopup;
